import styled from 'styled-components';
import { MediaViewer } from './MediaViewer';

const StyledMediaCardViewer = styled(MediaViewer)`
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`;

export { StyledMediaCardViewer };
